module.exports = __webpack_public_path__ + "img/hearanswer.a0381fb5.svg";